"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RUBICS_ORIGIN = "http://localhost:3000";
var Theme;
(function (Theme) {
    Theme["Light"] = "light";
    Theme["Dark"] = "dark";
})(Theme = exports.Theme || (exports.Theme = {}));
var MessageType;
(function (MessageType) {
    MessageType["SetTitle"] = "SetTitle";
    MessageType["SetLogo"] = "SetLogo";
    MessageType["SetBreadcrumbs"] = "SetBreadcrumbs";
    MessageType["PopState"] = "PopState";
    MessageType["SpawnModal"] = "SpawnModal";
    MessageType["SpawnNotification"] = "SpawnNotification";
    MessageType["ToggleTheme"] = "ToggleTheme";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
